export const config = {
  rowSelection: false,
  columns: [],
  search: [
    {
      name: "nameKeyword",
      label: "活动名称",
    },
    {
      name: "shopId",
      label: "适用门店",
      itemType: "select",
      key: 'id',
      labelKey: 'companyName',
      data: "companyOptions"
    },
    {
      name: "bizOpType",
      label: "需求标签",
      itemType: "select",
      key: 'value',
      data: "bizTypeOptions"
    },
     {
      name: "keyname",
      label: "SKU名称",
    },
     {
      name: "keyword",
      label: "编码",
      placeholder: "SKU_ID/SPU_ID/物料SPU编码/物料SKU编码"
    },
  ],
  footer: [
    {
      label: "新建活动",
      type: "primary",
      events: ["onClick:onAdd"]
    },
  ]
}
